const state = {
  step: { tabIndex: 0 },
  journey: ['home', 'paymentType', 'supplierTariff', 'usage'],
  initialised: false
};

const getters = {
  progress: (state, getters, rootState, rootGetters) => {
    const { journey } = state;
    const typeIndex = journey.indexOf(state.step);

    return (typeIndex + 1) * 100 / (journey.length);
  }
};

const actions = {
  getQuestions({ state, commit }, tabChildren) {
    const questions = tabChildren.map((child, tabIndex) => ({ q: child.title, tabIndex }));

    if (!state.initialised) {
      commit('initialiseJourney', questions);
    }
  },
  goToQuestion({ state, rootState, rootGetters, commit }, name) {
    const { journey } = state;
    const indexOfQuestion = journey.findIndex(({ q }) => q == name);

    return commit('updateState', { prop: 'step', value: journey[indexOfQuestion] });
  }
};

const mutations = {
  updateState(state, { prop, value }) {
    state[prop] = value;
  },
  initialiseJourney(state, questions) {
    const findQuestion = (stepName) => {
      return questions.find(item => item.q === stepName)
    };

    state.step = findQuestion(state.journey[0]);
    state.journey = state.journey.map(item => findQuestion(item));
    state.initialised = true;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

function removeFromArray(array, removeList) {
  return array.filter(item => removeList.indexOf(item) === -1);
}
